import React from "react";
import CameraEnhanceIcon from "@material-ui/icons/CameraEnhance";

interface Props {
  videoRef: React.MutableRefObject<HTMLVideoElement | null>;
  buttonStyles: string;
  videoTitle: string;
}

const SnapshotButton = ({ videoRef, buttonStyles, videoTitle }: Props) => {
  const takeSnapshot = () => {
    if (!videoRef.current) {
      return;
    }
    videoRef.current.style.filter = "brightness(2)";
    const removeFilterAndTakeSnapshot = () => {
      if (!videoRef.current) {
        return;
      }
      videoRef.current.style.filter = "";
      createAndDownloadSnapshot();
    };
    setTimeout(removeFilterAndTakeSnapshot, 50);
  };

  function createAndDownloadSnapshot() {
    if (videoRef.current) {
      const video = videoRef.current;
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      const ctx = canvas.getContext("2d");
      ctx?.drawImage(video, 0, 0, canvas.width, canvas.height);
      const dataURI = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataURI;
      link.download = `anavio_snapshot_${videoTitle}_${new Date().toISOString()}.png`;
      link.click();
      link.remove();
    }
  }

  return (
    <button id="playbackSnapshot" className={buttonStyles} type="button" onClick={takeSnapshot}>
      <CameraEnhanceIcon />
    </button>
  );
};

export default SnapshotButton;
